import React, { Component } from 'react';
import Helmet from 'react-helmet';
import {BrowserRouter as Router, Switch,Route,Link} from "react-router-dom";
import Pagination from '../components/pagination-business';
import Form from '../_partials/contac-form';
class Contact extends Component {
	render(){
		const heroImage =  {
        backgroundImage:`url(${process.env.PUBLIC_URL+ "include/images/contact-banner.jpg"})`
    	};
    	const TITLE = 'BACKSure - Contact us'
		return (
			<>
				<Helmet>
	                <title>{TITLE}</title>
	            </Helmet>
				<div className="hero-container d-flex align-items-center">
				    <div className="hero-bg" style={heroImage}></div>
				    <div className="container">
				        <div className="row">
				            <div className="col-md-5 offset-md-1">
				                <div className="hero-text">
				                    <h2>Let’s <span>Talk</span></h2>
				                    <p>Integer odio diam, iaculis a leo sed, accumsan ornare justo. Nulla tincidunt convallis egestas. Donec vitae semper erat.</p>
				                </div>
				            </div>
				        </div>
				    </div>
				    <div className="page-scroll d-none d-md-block">
				        <div className="scroll-wheel" onClick="document.getElementById('title').scrollIntoView()"></div>
				    </div>
				</div>
				<div className="content-container contact-form-container">
				    <div className="container">
				        <Form />
				    </div>
				</div>
				<Pagination />
			</>
		);
	};
}
export default Contact;